import { Button } from 'core-components/library/button'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

interface IPropertyTooltip {
  tooltip: string
}

export const PropertyTooltip = ({ tooltip }: IPropertyTooltip) => {
  return (
    <Tooltip
      horizontalDirection={TPopupHorizontal.Center}
      horizontalStartPosition={TPopupHorizontal.Center}
      tipContent={() => <div>{tooltip}</div>}
    >
      <Button iconButton={'kbase kbase-question'} color={'grey'} />
    </Tooltip>
  )
}
